//ng build --configuration=staging
export const environment = Object.freeze({
  production: false,
  displaySelflearnRecommendedVideos:true,
  displayProPlus: true,
  doBajajEncryption:true,
  sendTrackAPIOnSignInOrSignUp:true,
  displayNewPayInParts:true,
  useV1API: true,
  enableJodoEMIResume: true,
  enableResumeJodoFlex: true,
  displayShopSe: true,
  websitedisplayShopSe: true,
  displayEarlySalary: true,
  websitedisplayEarlySalary: true,
  packageExpiredCheck: true,
  liveClassPlayList:true,
  convertTOEMI: true,
  partPyamentBatchFix: true,
  myActivity : true,
  pypPdf:true,
  displayShippingCity:true,
  enableLcUIChanges: true,
  expiryWithDateTime:true,
  reportRevamp:true,
  websiteBlockLiveclasses: true,
  enablePackageUpgrade:true,
  enablePackageUpgradeV2:true,
  checkLiveClassEnroll:true,
  redirectToSubscription:true,
  displaySelfLearnV2: true,
  displayUPIIntentFlow: true,
  propelldApplicationFlag:true,
  eduvanzApplicationFlag:true,
  avanseApplicationFlag:true,
  youtubeLiveClassPlaylist: true,
  displayAssignmentGrade_8_to_13_revamp: true,
  isEduvanzShow: true,
  isPropelldShow: true,
  isAvanseShow: true,
  displayPopUpBlocker: true,
  proplldOrderStatus:true,
  enablePeakMind: true,
  inviteViaContacts: true,
  autoRedirectionfix:true,
  enableAbort: true,
  enableBestSubjectChanges: true,
  newHeaderFlag:true,
  enableAssignmentLazyload:true, 
  newAdvancePropelledFlag:true,
  earlySalaryWebsireRedirectionUrl: 'https://portal-uat.earlysalary.com/SignUp',
  api: 'https://stagingapi.devinfinitylearn.in',
  // api1: 'https://asmstagingapi.devinfinitylearn.in/v2/',
  api1: 'https://newasmstageapi.devinfinitylearn.in/',
  // apiNew: 'https://asmstagingapi.devinfinitylearn.in/v2/', old API base URL
  apiNew: 'https://newasmstageapi.devinfinitylearn.in/', // new API base url
  cyotdevApi: 'https://newqbapistage.devinfinitylearn.in/',
  tenant: 'infinitylearn',
  portal: 'assessment', //'teacher' //assessment
  branch: 'staging',
  ePragnaUrl: 'https://auth.epraghna.com',
  FRONT_END_URL: 'https://dashboard.devinfinitylearn.in/',
  ZOOM_LEAVE_URL: 'https://dashboard.devinfinitylearn.in/dashboard/liveclass',
  WEB_SOCKET_URI: 'https://livestagingapi.devinfinitylearn.in',
  LIVE_CLASS_API: 'https://livestagingapi.devinfinitylearn.in/api/v1/',
  LIVE_CLASS_API_V2: 'https://livestagingapi.devinfinitylearn.in/api/v2/',
  myActivity_url: 'https://myactivitystgapi.devinfinitylearn.in/',
  // LIVE_CLASS_API: 'https://liveclassapi.infinitylearn.com/api/v1/',
  omsdevapi: 'https://omsstagingapi.devinfinitylearn.in/api/',
  uafapi: 'https://myactivitystgapi.devinfinitylearn.in/api/',
  usersapi: 'https://stagingapi.devinfinitylearn.in/api/',
  SELF_LEARN_API: 'https://stagingselflearnapi.devinfinitylearn.in',
  SELF_LEARN_API_V2: 'https://selflearnapiv2.devinfinitylearn.net/',
  // omsdevapi: 'https://omsdevapi.devinfinitylearn.in/api/',
  CMS_API: 'https://cmsapi.devinfinitylearn.in/',
  razorkey: 'rzp_test_12ntRUqV41EEBk',
  homeRoute: 'https://staging.devinfinitylearn.in/',
  studentDashboard: 'https://staging.devinfinitylearn.in/',
  AGORA_APP_ID: 'ba17e305035c48a39811bd55400ec84b',
  TRACKJS_KEY: '75794dfef37745f3953a791f0e464344',
  wizKlubBase: 'https://dev.wizklub.com',
  rewardCardKey: 'ReferralAwardsDebug',
  wizclienttooken:'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwdWJsaWNfa2V5IjoibGRqb0F2cDFpQmZUTlVfVEJEXy0iLCJhcHBfbmFtZSI6IklORklOSVRZTEVBUk4ifQ.ws4FBkblCpIqP8VwFzKo5VAfzq7VAvLnmvSqZsAeD-k',
  peakmindenpoint :'https://qa.assessment.peakmind.in/?organizationId=c99aa146-18e6-48dc-a50c-3c539a925417&token=peecaxad24xzy',
  stageeosapi:'https://stageeosapi.devinfinitylearn.in/student/',
  LEARN_BE_EVENT_API: "https://learndevapi.devinfinitylearn.in/",
  GOAL_SETTING_URL: 'https://goalstgapi.devinfinitylearn.in/',
  EXAM_ID_CONVERSION_FROM_UAM_TO_CMS: [
    { CMS_ID: 1, UAM_ID: 2 },
    { CMS_ID: 2, UAM_ID: 1 },
    { CMS_ID: 3, UAM_ID: 5 },
    { CMS_ID: 4, UAM_ID: 11 },
    { CMS_ID: 5, UAM_ID: 10 },
    { CMS_ID: 12, UAM_ID: 12 },
  ],
  firebase:{
    apiKey: "AIzaSyBOvjfYqrlsYHALU936NXq7MZjXDDudl2c",
    authDomain: "doubts-aa0c1.firebaseapp.com",
    databaseURL: "https://doubts-aa0c1-default-rtdb.firebaseio.com",
    projectId: "doubts-aa0c1",
    storageBucket: "doubts-aa0c1.appspot.com",
    messagingSenderId: "339511367616",
    appId: "1:339511367616:web:6f17eae5ca85b21026da25",
    measurementId: "G-TYE54HH585"
  },
  messages:'staging_chats',
  status:'status_stag',
  gtm:'GTM-TCS6GVV',
  displayDoubtsWeb: true,
  dcapi: 'https://dcapi-staging.devinfinitylearn.in',
  dsrapi: 'https://drs.devinfinitylearn.in/',
  Domain : '.devinfinitylearn.in',

  Bajaj: {
    showBajaj: true,
    min_amount: 1,
    max_amount: 2,
    Durations: [
      { tenor: 3, schemeId: "81526" },
      { tenor: 6, schemeId: "81527" },
    ],
  },
  showEarlySalary: true,
  Jodo: {
    jodo_auth_host: "https://api.devtest1.jodopay.com",
    displayCred: true,
    displayFlex: true,
    websitedisplayCred: true,
    websitedisplayFlex: true,
  },
  successHome: 'https://success-centersdev.devinfinitylearn.in/',
  scoreToiURL: 'https://us-central1-times-stem.cloudfunctions.net/timesApi/addUserTest',
  scoreToiStatusURL: 'https://us-central1-times-stem.cloudfunctions.net/timesApi/updateScoreStatusTest',
  scoreToiKey: 123,
  scatHome: 'https://srichaitanyascore.devinfinitylearn.in/',
  UAM_TO_CMS_CONVERSION : [
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "13th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 13,
      "UAM_exam_id": 2,
      "UAM_grade_id": 16,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 13
    },
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 2,
      "UAM_grade_id": 12,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "11th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 11,
      "UAM_exam_id": 2,
      "UAM_grade_id": 11,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 11
    },
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "10th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 10,
      "UAM_exam_id": 2,
      "UAM_grade_id": 10,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 10
    },
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "9th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 9,
      "UAM_exam_id": 2,
      "UAM_grade_id": 18,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 9
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "13th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 13,
      "UAM_exam_id": 1,
      "UAM_grade_id": 16,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 13
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 1,
      "UAM_grade_id": 12,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "11th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 11,
      "UAM_exam_id": 1,
      "UAM_grade_id": 11,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 11
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "10th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 10,
      "UAM_exam_id": 1,
      "UAM_grade_id": 10,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 10
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "9th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 9,
      "UAM_exam_id": 1,
      "UAM_grade_id": 18,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 9
    },
    {
      "UAM_Exam_Name": "JEE Advanced",
      "UAM_Grade_Name": "13th",
      "CMS_Exam_Name": "JEE Advanced",
      "CMS_Grade_Name": 13,
      "UAM_exam_id": 5,
      "UAM_grade_id": 16,
      "CMS_Exam_id": 3,
      "CMS_grade_id": 13
    },
    {
      "UAM_Exam_Name": "JEE Advanced",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "JEE Advanced",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 5,
      "UAM_grade_id": 12,
      "CMS_Exam_id": 3,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "JEE Advanced",
      "UAM_Grade_Name": "11th",
      "CMS_Exam_Name": "JEE Advanced",
      "CMS_Grade_Name": 11,
      "UAM_exam_id": 5,
      "UAM_grade_id": 11,
      "CMS_Exam_id": 3,
      "CMS_grade_id": 11
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "CBSE Grade 12",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 12,
      "UAM_grade_id": 12,
      "CMS_Exam_id": 12,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "11th",
      "CMS_Exam_Name": "CBSE Grade 11",
      "CMS_Grade_Name": 11,
      "UAM_exam_id": 12,
      "UAM_grade_id": 11,
      "CMS_Exam_id": 11,
      "CMS_grade_id": 11
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "10th",
      "CMS_Exam_Name": "CBSE Grade 10",
      "CMS_Grade_Name": 10,
      "UAM_exam_id": 12,
      "UAM_grade_id": 10,
      "CMS_Exam_id": 10,
      "CMS_grade_id": 10
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "9th",
      "CMS_Exam_Name": "CBSE Grade 9",
      "CMS_Grade_Name": 9,
      "UAM_exam_id": 12,
      "UAM_grade_id": 18,
      "CMS_Exam_id": 9,
      "CMS_grade_id": 9
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "8th",
      "CMS_Exam_Name": "CBSE Grade 8",
      "CMS_Grade_Name": 8,
      "UAM_exam_id": 12,
      "UAM_grade_id": 21,
      "CMS_Exam_id": 8,
      "CMS_grade_id": 8
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "7th",
      "CMS_Exam_Name": "CBSE Grade 7",
      "CMS_Grade_Name": 7,
      "UAM_exam_id": 12,
      "UAM_grade_id": 20,
      "CMS_Exam_id": 7,
      "CMS_grade_id": 7
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "6th",
      "CMS_Exam_Name": "CBSE Grade 6",
      "CMS_Grade_Name": 6,
      "UAM_exam_id": 12,
      "UAM_grade_id": 22,
      "CMS_Exam_id": 6,
      "CMS_grade_id": 6
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "5th",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 5,
      "UAM_exam_id": 10,
      "UAM_grade_id": 32,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 5
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "4th",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 4,
      "UAM_exam_id": 10,
      "UAM_grade_id": 31,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 4
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "3rd",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 3,
      "UAM_exam_id": 10,
      "UAM_grade_id": 26,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 3
    },
    {
      "UAM_Exam_Name": "Foundation Test",
      "UAM_Grade_Name": "8th",
      "CMS_Exam_Name": "Foundation Test",
      "CMS_Grade_Name": 8,
      "UAM_exam_id": 11,
      "UAM_grade_id": 21,
      "CMS_Exam_id": 4,
      "CMS_grade_id": 8
    },
    {
      "UAM_Exam_Name": "Foundation Test",
      "UAM_Grade_Name": "7th",
      "CMS_Exam_Name": "Foundation Test",
      "CMS_Grade_Name": 7,
      "UAM_exam_id": 11,
      "UAM_grade_id": 20,
      "CMS_Exam_id": 4,
      "CMS_grade_id": 7
    },
    {
      "UAM_Exam_Name": "Foundation Test",
      "UAM_Grade_Name": "6th",
      "CMS_Exam_Name": "Foundation Test",
      "CMS_Grade_Name": 6,
      "UAM_exam_id": 11,
      "UAM_grade_id": 22,
      "CMS_Exam_id": 4,
      "CMS_grade_id": 6
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "1st",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 1,
      "UAM_exam_id": 10,
      "UAM_grade_id": 34,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 1
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "2nd",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 2,
      "UAM_exam_id": 10,
      "UAM_grade_id": 33,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 2
    },
    {
      "UAM_Exam_Name": "CUET",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "CUET",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 28,
      "UAM_grade_id": 12,
      "CMS_Exam_id": 28,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "RMO",
      "UAM_Grade_Name": "8th",
      "CMS_Exam_Name": "RMO",
      "CMS_Grade_Name": 8,
      "UAM_exam_id": 30,
      "UAM_grade_id": 21,
      "CMS_Exam_id": 31,
      "CMS_grade_id": 8
    },
    {
      "UAM_Exam_Name": "RMO",
      "UAM_Grade_Name": "9th",
      "CMS_Exam_Name": "RMO",
      "CMS_Grade_Name": 9,
      "UAM_exam_id": 30,
      "UAM_grade_id": 18,
      "CMS_Exam_id": 31,
      "CMS_grade_id": 9
    },
    {
      "UAM_Exam_Name": "RMO",
      "UAM_Grade_Name": "10th",
      "CMS_Exam_Name": "RMO",
      "CMS_Grade_Name": 10,
      "UAM_exam_id": 30,
      "UAM_grade_id": 10,
      "CMS_Exam_id": 31,
      "CMS_grade_id": 10
    },
    {
      "UAM_Exam_Name": "IJSO",
      "UAM_Grade_Name": "7th",
      "CMS_Exam_Name": "IJSO",
      "CMS_Grade_Name": 7,
      "UAM_exam_id": 29,
      "UAM_grade_id": 20,
      "CMS_Exam_id": 32,
      "CMS_grade_id": 7
    },
    {
      "UAM_Exam_Name": "IJSO",
      "UAM_Grade_Name": "8th",
      "CMS_Exam_Name": "IJSO",
      "CMS_Grade_Name": 8,
      "UAM_exam_id": 29,
      "UAM_grade_id": 21,
      "CMS_Exam_id": 32,
      "CMS_grade_id": 8
    },
    {
      "UAM_Exam_Name": "IJSO",
      "UAM_Grade_Name": "9th",
      "CMS_Exam_Name": "IJSO",
      "CMS_Grade_Name": 9,
      "UAM_exam_id": 29,
      "UAM_grade_id": 18,
      "CMS_Exam_id": 32,
      "CMS_grade_id": 9
    },
  ],
  // cyotNewflow:true

});
